import { ReactElement, useMemo } from 'react'
import { ValidationTag } from '../Common/interfaces'
import styled from 'styled-components'
import { I18n, Translate } from 'src/i18n'
import { getTagInfo } from './helper'
import { defaultTheme } from 'src/theme'

interface Props {
  type: ValidationTag
}

const textStyle = {
  paddingLeft: '0.3rem',
  color: defaultTheme.colors.almostBlack,
}

const ValidationMessage = (props: Props): ReactElement => {
  const { type } = props

  const info = useMemo(() => getTagInfo(type), [type])

  const label = Translate(info.label) + (info.description ? ': ' : ' ')

  return (
    <Wrapper style={{ ...info }}>
      {info.icon}
      <span style={textStyle}>
        <b>{label}</b>
        <I18n name={info.description} />
      </span>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  padding: 0.3rem 0.5rem 0.3rem 0.5rem;
  margin: 0.5rem 0rem 2rem 0rem;
  min-height: 47px;
  padding: 12px 16px 12px 16px;
`

export default ValidationMessage
